"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
var React = __importStar(require("react"));
var Logo_1 = require("../Logo/Logo");
var Popup_1 = require("../Popup/Popup");
var AvatarFace_1 = require("../AvatarFace/AvatarFace");
var Blockie_1 = require("../Blockie/Blockie");
require("./Profile.css");
var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Profile.prototype.render = function () {
        var _a = this.props, address = _a.address, avatar = _a.avatar, textOnly = _a.textOnly, imageOnly = _a.imageOnly, hasPopup = _a.hasPopup, inline = _a.inline, size = _a.size, sliceAddressBy = _a.sliceAddressBy, isDecentraland = _a.isDecentraland;
        var sliceLimit = Math.max(Math.min(sliceAddressBy, 42), 6);
        var name = (avatar && avatar.name) || address.slice(0, sliceLimit);
        if (isDecentraland) {
            return (React.createElement("span", { className: "Profile decentraland ".concat(size, " ").concat(inline ? 'inline' : ''), title: address },
                React.createElement(Logo_1.Logo, null),
                imageOnly ? null : React.createElement("span", { className: "name" }, "Decentraland")));
        }
        if (textOnly) {
            return name;
        }
        else {
            return (React.createElement(Popup_1.Popup, { content: name, disabled: !hasPopup, position: "top center", trigger: avatar ? (React.createElement("span", { className: "Profile avatar ".concat(size, " ").concat(inline ? 'inline' : ''), title: address },
                    React.createElement(AvatarFace_1.AvatarFace, { size: "tiny", inline: inline, avatar: avatar }),
                    imageOnly ? null : React.createElement("span", { className: "name" }, name))) : (React.createElement("span", { className: "Profile blockie ".concat(size, " ").concat(inline ? 'inline' : ''), title: address },
                    React.createElement(Blockie_1.Blockie, { seed: address, scale: size === 'large'
                            ? 5
                            : size === 'huge'
                                ? 7
                                : size === 'massive'
                                    ? 21
                                    : 3 }),
                    imageOnly ? null : React.createElement("span", { className: "name" }, name))) }));
        }
    };
    Profile.defaultProps = {
        inline: true,
        sliceAddressBy: 6,
        size: 'normal'
    };
    return Profile;
}(React.PureComponent));
exports.Profile = Profile;
